import { FormTypeEnum, IPageProps } from 'types'
import WebsiteLeadsFilterForm from 'components/Integrations/WebsiteLeadsFilter/WebsiteLeadsFilterForm'
import { WebLeadFilterDto } from 'generated/v1/v1IntegrationsApi'
import { V1ApiIntegrationsClient } from 'core/http-common'

const WebsiteLeadsFilterAddPage = ({ title }: IPageProps) => {

    const addWebLeadFilter = async (webLeadFilter: WebLeadFilterDto) => {
        return V1ApiIntegrationsClient.createWebLeadFilter(webLeadFilter)
    }

    return (
        <WebsiteLeadsFilterForm 
            title={title} 
            formType={FormTypeEnum.Add}
            AddOrUpdateWebLeadFilter={addWebLeadFilter}
        />
    )
}
export default WebsiteLeadsFilterAddPage
